import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"

const sectionStyle = {
  border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px",
  marginBottom: "16px", background: "#fff"
}
const sectionTitle = (icon, title) => (
  <h6 style={{ color: "#6366f1", marginBottom: "14px", fontSize: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
    <i className={`fas ${icon}`} style={{ fontSize: "13px" }}></i>{title}
  </h6>
)

const EditTransporter = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [trans, setTrans] = useState({})
  const [dataLoaded, setDataLoaded] = useState(false)

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const response = await api.put("update-transporter/" + id, values)
      if (response.data.success === true) setSubmitted(true)
    } catch (error) {
      // Handled by global interceptor
    }
    setLoading(false)
  }

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    try {
      const resp = await api.get("transporter/" + id)
      const data = Array.isArray(resp.data.data) ? resp.data.data[0] : resp.data.data
      setTrans(data || {})
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }

  if (!dataLoaded) return <div className="text-center p-5"><Spinner color="primary" /></div>

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Edit Transporter</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/transporters" className="dashBtn">
                <i className="fas fa-chevron-left"></i> <b>Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm style={{ position: "relative" }} className="form-horizontal"
            onValidSubmit={(e, v) => handleValidSubmit(e, v)}>

            <div style={sectionStyle}>
              {sectionTitle("fa-truck", "Transporter Information")}
              <Row>
                <Col md={6}><div className="mb-3"><AvField name="transporterName" label="Transporter Name *" value={trans.transporterName || ""} type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="phone" label="Phone" value={trans.phone || ""} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="email" label="Email" value={trans.email || ""} type="email" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="address" label="Address" value={trans.address || ""} type="textarea" rows="2" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="gst" label="GST" value={trans.gst || ""} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="pan" label="PAN" value={trans.pan || ""} type="text" /></div></Col>
              </Row>
            </div>

            <div style={sectionStyle}>
              {sectionTitle("fa-cog", "Settings")}
              <Row>
                <Col md={6}><div className="mb-3">
                  <AvRadioGroup inline name="paymentMode" label="Payment Mode *" required value={trans.paymentMode || "cash"}>
                    <AvRadio label="Cash" value="cash" /><AvRadio label="Account" value="account" />
                  </AvRadioGroup>
                </div></Col>
                <Col md={6}><div className="mb-3">
                  <AvRadioGroup inline name="tdsApplicable" label="TDS Applicable for Billing *" required value={String(trans.tdsApplicable || "0")}>
                    <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
                  </AvRadioGroup>
                </div></Col>
              </Row>
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success"><strong>Transporter is Updated!</strong></UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                  {loading ? (
                    <><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></>
                  ) : (
                    <span>Update Transporter</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditTransporter
